var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { getIntersectionObserverConstructor } from "sb-helpers";
// THIS FILE IS IGNORED FROM COVERAGE REPORT
/*
    The switch between IntersectionObserver and the FakeIntersectionObserver
    is impossible to test due to lack of support on behalf of NodeJS.

    This API is not applicable on the serverside however this allows us
    to do good tests for the FakeIntersectionObserver.
*/
const defaultsOptions = {
    // root: null,
    rootMargin: "0px",
    threshold: .01
};
export class Renderer {
    constructor(props) {
        let _OBS = getIntersectionObserverConstructor();
        this.observer = new _OBS(this.updateOnIdle.bind(this), Object.assign(Object.assign({}, defaultsOptions), props));
        this.isVisible = this.observer["faked"] || false;
    }
    registerDom(element) {
        this.observer.observe(element);
    }
    unRegisterDom(element) {
        this.observer.unobserve(element);
    }
    updateOnIdle(entries) {
        window.cancelAnimationFrame(this.idleCallbackID);
        this.idleCallbackID = window.requestAnimationFrame(() => {
            this.updateVisibility(entries);
        });
    }
    updateVisibility(entries) {
        this.isVisible = entries[0].isIntersecting;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Renderer.prototype, "isVisible", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Renderer.prototype, "updateVisibility", null);
//# sourceMappingURL=Renderer.js.map